import { handleActions } from "redux-actions";
import { MERCHANT } from "constants/action-types";
import { IQuery, IMutate, RequestStatus } from "constants/crud";
import { GetMerchantPreferenceRequestAction, GetMerchantPreferenceCompleteAction } from "actions/merchant";
import { IMerchantPreference } from "constants/merchant";

export interface IState extends IQuery<IMerchantPreference>, IMutate<IMerchantPreference> {}

const initialState: IState = {
    queryError: undefined,
    queryStatus: RequestStatus.Active,
    mutateStatus: RequestStatus.Idle,
    mutateError: undefined,
    result: undefined,
};

export const merchantPreference = handleActions<IState, any>(
    {
        [MERCHANT.PREFERENCE.GET.REQUEST]: (state: IState, _action: GetMerchantPreferenceRequestAction): IState => {
            return {
                ...state,
                ...initialState,
            };
        },
        [MERCHANT.PREFERENCE.GET.COMPLETE]: (state: IState, action: GetMerchantPreferenceCompleteAction): IState => {
            return {
                ...state,
                queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                queryError: action.payload instanceof Error ? action.payload : undefined,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
    } as any,
    initialState,
);
